export const CLIENT_ID='618674730123-upnccahmpf5amp8ij1qcgdie3d11ch32.apps.googleusercontent.com';
export const CALLBACK='https://app.itsbloxx.com/integrations/google/callback';
const PREFIX='https://www.googleapis.com/auth/';
// ga4 is READ-ONLY and calendar is not a default: Google's verification review
// requires the consent screen to match the console's scope list exactly (26 Sep
// 2026). Write and calendar scopes are asked for incrementally via ga4_write /
// products:['calendar']. Xano fn 992 google/start_authorization mirrors this map.
// calendar is the narrow pair since 14 Oct 2026: free/busy on the owner's own calendars, and
// read/write only on the "Bloxx bookings" calendar Bloxx creates (calendar.app.created). It
// replaced calendar.events (every event in every calendar) for Google's verification review.
export const PRODUCTS={ga4:[PREFIX+'analytics.readonly'],ga4_write:[PREFIX+'analytics.edit'],gsc:[PREFIX+'webmasters.readonly',PREFIX+'webmasters'],gsc_write:[PREFIX+'webmasters'],verification:[PREFIX+'siteverification'],gbp:[PREFIX+'business.manage'],google_ads:[PREFIX+'adwords'],gtm:[PREFIX+'tagmanager.readonly'],gtm_write:[PREFIX+'tagmanager.edit.containers',PREFIX+'tagmanager.edit.containerversions',PREFIX+'tagmanager.publish'],calendar:[PREFIX+'calendar.app.created',PREFIX+'calendar.freebusy']};
const plain=x=>x!==null&&typeof x==='object'&&!Array.isArray(x);
const same=(a,b)=>JSON.stringify(a)===JSON.stringify(b);
export function normalizeInput(raw,existing){
 if(!plain(raw)||Object.keys(raw).some(k=>!['redirect_uri','mode','products'].includes(k))||raw.redirect_uri!==CALLBACK)throw new Error('GOOGLE_OAUTH_INVALID_REQUEST');
 const mode=raw.mode??(existing?'upgrade':'initial');
 const products=raw.products??['ga4','gsc','verification'];
 if(!['initial','upgrade','recover'].includes(mode)||!Array.isArray(products)||!products.length||products.some(p=>typeof p!=='string'||!Object.hasOwn(PRODUCTS,p)))throw new Error('GOOGLE_OAUTH_INVALID_REQUEST');
 return {redirect_uri:CALLBACK,mode,products:[...new Set(products)].sort()};
}
export function requestConfig(input){
 const scopes=[...new Set([...(input.mode==='upgrade'?[]:['openid','email','profile']),...input.products.flatMap(p=>PRODUCTS[p])])].sort();
 return {...input,scopes:scopes.join(' '),requested_scopes:scopes,access_type:'offline',include_granted_scopes:true,prompt:input.mode==='recover'?'consent':null};
}
export function validConfig(c,input){
 return plain(c)&&same(c,requestConfig(input));
}
export function prepare(raw,existing,clientId,makeConfig=requestConfig){
 let input;
 try{input=normalizeInput(raw,existing);}catch{return {ok:false,status:400,error:{code:'GOOGLE_OAUTH_INVALID_REQUEST',message:'The Google connection request is invalid.'}};}
 try{
  if(clientId!==CLIENT_ID)throw Error();
  const config=makeConfig(input);
  if(!validConfig(config,input))throw Error();
  return {ok:true,config};
 }catch{return {ok:false,status:500,error:{code:'GOOGLE_OAUTH_CONFIGURATION_INVALID',message:'Bloxx could not prepare the Google connection.'}};}
}
export function validatePrepared(result,raw,existing){
 try{return plain(result)&&result.ok===true&&validConfig(result.config,normalizeInput(raw,existing));}catch{return false;}
}
export function finish(config,state,requestId){
 if(!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(state))throw Error('Invalid state');
 const url=new URL('https://accounts.google.com/o/oauth2/v2/auth');
 const params={client_id:CLIENT_ID,redirect_uri:config.redirect_uri,response_type:'code',scope:config.scopes,state,access_type:config.access_type,include_granted_scopes:'true'};
 if(config.prompt)params.prompt=config.prompt;
 for(const [k,v]of Object.entries(params))url.searchParams.set(k,v);
 return {ok:true,schema_version:3,request_id:requestId,...config,client_id:CLIENT_ID,state,authorization_url:url.toString()};
}
export function validateResponse(r){
 try{
  if(!plain(r)||r.ok!==true||r.schema_version!==3||r.client_id!==CLIENT_ID)return false;
  const expected=finish(requestConfig(normalizeInput({redirect_uri:r.redirect_uri,mode:r.mode,products:r.products},false)),r.state,r.request_id);
  return same(Object.keys(r).sort(),Object.keys(expected).sort())&&Object.keys(expected).every(k=>same(r[k],expected[k]));
 }catch{return false;}
}
